<div class="alert-failure" *ngIf="showNoSupplierErrMsg">
  <img style="margin-right:1em;" src="../assets/images/errCircle.png" alt="failureMsg">
  <span>{{pageErrorMsg}}</span>
</div>

<div *ngIf="isDisplay">
  <div>
    <a class="homePageLinks cursorptr ms-3" [attr.href]="appRefDocLink" id="appRefDoc" target="_blank"
      style="font-size:12px;text-decoration:none;">APP Reference Documents</a>
  </div>

  <div class="topBox">
    <span class="ms-3" style="color:#FBFBFC;font-size:small">APP Packet Approval Information</span>
  </div>

  <div class="container-fluid">
    <div class="row pe-2">
      <div class="col-12 col-md-12 m-1">
        <div class="customBox d-flex">
          <div class="col-md-2">
            <div class="innerCustomBox-before" (click)="applyActiveClass(1,$event)" (keyup)="applyActiveClass(1,$event)"
              [ngClass]="{innerCustomBox:tab1}">
              <div class="d-flex">
                <div class="commonFont">{{totalPacket}}</div>
                <div class="percentageBox label-tmna mt-2" style="visibility:hidden;">{{totalPacketPercentage}}%</div>
              </div>
              <div class="label-tmna">Total number of packets</div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="innerCustomBox-before" (click)="applyActiveClass(2,$event)" (keyup)="applyActiveClass(2,$event)"
              [ngClass]="{innerCustomBox:tab2}">
              <div class="d-flex">
                <div class="commonFont">{{approvedpacket}}</div>
                <div class="percentageBox label-tmna mt-2">{{approvedpacketPercentage}}%</div>
              </div>
              <div class="label-tmna">Approved packets</div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="innerCustomBox-before" (click)="applyActiveClass(3,$event)" (keyup)="applyActiveClass(3,$event)"
              [ngClass]="{innerCustomBox:tab3}">
              <div class="d-flex">
                <div class="commonFont">{{packetNotSent}}</div>
                <div class="percentageBox label-tmna mt-2">{{packetNotSentPercentage}}%</div>
              </div>
              <div class="label-tmna">Packets Not Sent</div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="innerCustomBox-before" (click)="applyActiveClass(4,$event)" (keyup)="applyActiveClass(4,$event)"
              [ngClass]="{innerCustomBox:tab4}">
              <div class="d-flex">
                <div class="commonFont">{{openPacket}}</div>
                <div class="percentageBox label-tmna mt-2">{{openPacketPercentage}}%</div>
              </div>
              <div class="label-tmna">Open packets</div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="innerCustomBox-before" (click)="applyActiveClass(5,$event)" (keyup)="applyActiveClass(5,$event)"
              [ngClass]="{innerCustomBox:tab5}">
              <div class="d-flex">
                <div class="commonFont">{{inprogressPacket}}</div>
                <div class="percentageBox label-tmna mt-2">{{inprogressPacketPercentage}}%</div>
              </div>
              <div class="label-tmna">In progress packets</div>
            </div>
          </div>

          <div class="col-md-2">
            <div class="innerCustomBox-before" (click)="applyActiveClass(6,$event)" (keyup)="applyActiveClass(6,$event)"
              [ngClass]="{innerCustomBox:tab6}">
              <div class="d-flex">
                <div class="commonFont">{{readyforreviewPacket}}</div>
                <div class="percentageBox label-tmna mt-2">{{readyforreviewPacketPercentage}}%</div>
              </div>
              <div class="label-tmna">Packets ready for manager review</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="flex-row d-flex">
      <div class="col-4 col-md-4 me-1 p-1">
        <div class="supplierBox commonFont">
          <span class="ms-2 pt-2">{{fiscalyearlabel}}</span>
        </div>

        <div class="cursorptr searchBar p-1" style="background-color:#E4ECF0;">
          <input type="text" #searchBox [(ngModel)]="searchSupplier" (ngModelChange)="onSearchChange()"
            class="form-control addsearch search-tmna" placeholder="Search here">
          <img class="ms-1" src="\assets\images\search.svg" alt="img">
        </div>

        <div #listBox class="supplierContainer">
          <option class="supplierList displayTextcss list-item" *ngFor="let suppList of filteredSupplier;let i=index"
            (keyup)="selectSupplier(i)" (click)="selectSupplier(i)" [class.selected]="i===selectedFilterIndex">
            {{suppList}}
          </option>
        </div>

        <div class="mt-2 mb-2">
          <span class="label-tmna mt-2 mb-2" style="font-style:italic;">* denotes you as the lead buyer</span>
        </div>
      </div>

      <div class="col-8 col-md-8 ms-1 p-1">
        <div class="row">
          <div class="d-flex justify-content-between p-2">
            <div class="d-flex flex-row ms-1">
              <span class="heading pe-2">{{selectedSupplierBuyerInfo}}</span>
            </div>

            <div class="d-flex flex-row me-2 pe-1">
              <a class="homePageLinks me-2" [ngClass]="{'noSuppliers':disableISEReportsLink}"
                routerLink="/ise">View/Edit ISE</a>
              <a class="homePageLinks ms-2 showhand" [ngClass]="{'noSuppliers':disableISEReportsLink}"
                (click)="generatePDF()">View Report</a>
            </div>
          </div>
        </div>

        <div class="accordion-wrapper">
          <div class="accordion mb-2 me-2" id="homeAccordianOne">
            <div class="card">
              <div class="card-header">
                <div class="d-flex flex-row justify-content-between">
                  <span class="commonFont pt-2">SUPPLIER DETAILS</span>
                  <button class="btn headButton" type="button" data-bs-toggle="collapse" id="accordion3Btn"
                    accordianActive="true" data-bs-target="#collapsesearchfilter" aria-expanded="true"
                    aria-controls="collapsesearchfilter" (click)="isOpen1=!isOpen1">
                    <img class="clpseBtn collapsesearchfilterBtn" [ngClass]="{'active':isOpen1}" alt="img">
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div id="collapsesearchfilter" class="collapse show me-2" aria-labelledby="headingOne"
            data-bs-parent="#proposalHist">
            <div class="cardBody">
              <div class="accordion-main">
                <div class="supplier-details-scroll">
                  <div class="supplier-target-fields">
                    <div class="supplier-target-field supplier-category-field">
                      <label for="imprTargetTitle" class="label-tmna supplier-target-label">TMNA Supplier
                        Category</label>
                      <select class="dropdown-tmna supplier-category-input" id="imprTargetTitle"
                        (change)="onSelectingImprvtTargetTitle()" [(ngModel)]="selectedImprTargetTitle"
                        [ngModelOptions]="{standalone:true}">
                        <option class="displayTextcss" *ngFor="let item of improvementTargetData;trackBy:trackByFn"
                          [value]="item.title">{{item.title}}</option>
                      </select>
                    </div>

                    <div class="supplier-target-field va-target-field">
                      <label for="vaCostReduction" class="label-tmna supplier-target-label">VA Submission Target
                        %</label>
                      <div class="target-input-help" style="margin-top: 20px;">
                        <input class="input-tmna va-target-input" type="text" id="vaCostReduction"
                          [value]="vacostreductiontarget" (input)="onVaCostInputChange($event)"
                          (keypress)="allowOnlyValidCharForVa($event)" (focusout)="onVaFocusOut()">
                        <span class="label-tmna resizeStyle target-help">{{isNegativeTargetYear()?'Only negative values
                          allowed':'Only positive values allowed'}}</span>
                      </div>
                    </div>

                    <div class="supplier-target-field apr-target-field">
                      <label class="label-tmna supplier-target-label">APR MI Target %</label>
                      <div class="target-input-help apr-target-input-help">
                        <div class="aprValueFlex">
                          <div class="aprValueField">
                            <span class="label-tmna">FY{{tmnaYearLabel}}</span>
                            <input class="input-tmna" type="text" id="vipmanuimpraprtarget" [value]="currentAPRtarget"
                              (input)="onInputChange($event)" (keypress)="allowOnlyValidChar($event)"
                              (focusout)="onFocusOut()">
                          </div>
                          <div class="aprValueField">
                            <span class="label-tmna">FY{{currentFiscalYear}}</span>
                            <input class="input-tmna" type="text" id="previoustarget" [value]="prevAPRtarget" disabled>
                          </div>
                        </div>
                        <span class="label-tmna resizeStyle target-help">{{isNegativeTargetYear()?'Only negative values
                          allowed':'Only positive values allowed'}}</span>
                      </div>
                    </div>
                  </div>

                  <div class="row pb-3">
                    <textarea class="label-tmna-big ms-4" id="imprTargetDesc" [value]="selectedImprTargetDesc" rows="5"
                      readonly></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex flex-row mt-3 mb-2 me-1">
          <div class="accordianwidth1 me-1" style="min-width:50%;">
            <div class="accordion-wrapper">
              <div class="accordion" id="homeAccordianTwo">
                <div class="card" style="border-bottom:none;">
                  <div class="card-header">
                    <div class="d-flex flex-row justify-content-between">
                      <span class="commonFont pt-2">SAFETY TARGET</span>
                      <button class="btn headButton" type="button" data-bs-toggle="collapse" id="accordion3Btn"
                        accordianActive="true" data-bs-target="#riskRanking" aria-expanded="true"
                        aria-controls="riskRanking" (click)="isOpen2=!isOpen2">
                        <img class="clpseBtn collapsesearchfilterBtn" [ngClass]="{'active':isOpen2}" alt="img">
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div id="riskRanking" class="collapse show" aria-labelledby="headingOne" data-bs-parent="#proposalHist">
                <ag-grid-angular class="ag-theme-balham" [rowData]="rowDataSafetyRisk"
                  [columnDefs]="columnDefsSafetyRisk" (gridReady)="onGridReady($event,'grid1')" [pagination]="true"
                  headerHeight="50" [defaultColDef]="defaultColDef" [paginationPageSize]="paginationPageSize"
                  [paginationPageSizeSelector]="paginationPageSizeSelector" [domLayout]="domLayout"></ag-grid-angular>
              </div>
            </div>
          </div>
        </div>

        <span *ngIf="dateApproved" class="label-tmna" style="font-style:italic;">Approved at {{dateApproved}}</span>
      </div>
    </div>
  </div>

  <nav class="navbar navbar-expand-lg justify-content-end footer-tab mt-2">
    <div class="saveFooter mb-3 me-2 pe-1">
      <button *ngIf="isManager&&!donotsend" class="addButton ms-3" (click)="approveDisapproveSupplierDetails()"
        [ngClass]="{'noSuppliers':disableButtons||(isManager&&!canManagerModifySupplier)}">
        <span *ngIf="approved">DISAPPROVE</span>
        <span *ngIf="!approved">APPROVE</span>
      </button>

      <button *ngIf="isManager&&readyForReview" class="closeButton ms-3"
        [ngClass]="{'noSuppliers':disableButtons||(isManager&&!canManagerModifySupplier)}" (click)="openModal()">
        SEND THIS SUPPLIER BACK TO BUYER
      </button>

      <button *ngIf="isManager" class="closeButton ms-3" (click)="doNotSendSupplierDetails()"
        [ngClass]="{'noSuppliers':disableButtons||(isManager&&!canManagerModifySupplier)}">
        <span *ngIf="donotsend">SEND</span>
        <span *ngIf="!donotsend">DO NOT SEND</span>
      </button>

      <button *ngIf="isManager||isAdmin||isBuyer" class="closeButton ms-3" (click)="saveSupplierDetails()"
        [ngClass]="{'disabled':!(isAdmin||isLeadBuyer||(isManager&&canManagerModifySupplier)),'noSuppliers':disableButtons,'supplierAprvd':approved,'supplierNoSend':donotsend&&approved}">
        SAVE
      </button>

      <button *ngIf="isBuyer&&inProgress" class="closeButton ms-3" [ngClass]="{'noSuppliers':disableButtons}"
        (click)="openModal()">
        READY FOR REVIEW
      </button>
    </div>
  </nav>
</div>

<div *ngIf="!isDisplay">
  <div class="container unauthorized" *ngIf="displayUnauthorised">
    <p></p>
    <p style="color:red;">You do not have a role assigned to access this Application.</p>
    <p>Please raise a request using <a style="color:#2688Da;text-decoration:underline"
        href="https://ep.idm.toyota.com/identityiq/home.jsf">SailPoint</a>.</p>
    <p>Please refer to the <span style="color:#2688Da;text-decoration:underline;cursor:pointer">User Guide</span> for
      more details.</p>
    <p style="color:#2688Da;text-decoration:underline;cursor:pointer;" (click)="cancelNullGuidAssume()"
      (keydown)="cancelNullGuidAssume()" *ngIf="cancelAssumedUser">Cancel Assume</p>
  </div>
</div>

<div class="modal" tabindex="-1" [ngClass]="{'show':showModal}" [ngStyle]="{'display':showModal?'block':'none'}">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content" *ngIf="isBuyer">
      <button type="button" class="close" data-bs-dismiss="modal" (click)="closeModal()">
        <img src="\assets\images\close-icon.png" alt="Close Modal" height="15" width="15">
      </button>

      <div class="modal-header" id="addModalHeader" style="display:flex;justify-content:space-between;align-items:end;">
        <h4 class="modal-title inl-modal-padding modalHeading">Confirm Dialog</h4>
      </div>

      <div class="modal-body">
        <span class="label-tmna">Please confirm if supplier report is ready for manager review.</span>
      </div>

      <div class="modal-footer">
        <button class="closeButton me-2" (click)="closeModal()">Cancel</button>
        <button class="addButton me-2" (click)="approvalStatusUpdate()">Confirm</button>
      </div>
    </div>

    <div class="modal-content" *ngIf="isManager">
      <button type="button" class="close" data-bs-dismiss="modal" (click)="closeModal()">
        <img src="\assets\images\close-icon.png" alt="Close Modal" height="15" width="15">
      </button>

      <div class="modal-header" id="addModalHeader" style="display:flex;justify-content:space-between;align-items:end;">
        <h4 class="modal-title inl-modal-padding modalHeading">Please provide comments/feedback to buyer</h4>
      </div>

      <div class="modal-body">
        <textarea class="label-tmna-big" [(ngModel)]="commentsFromManager" type="text" rows="3"
          style="width:100%;"></textarea>
      </div>

      <div class="modal-footer">
        <button class="closeButton me-2" (click)="closeModal()">Cancel</button>
        <button class="addButton me-2" (click)="approvalStatusUpdate()">Send to buyer</button>
      </div>
    </div>
  </div>
</div>